export class VolunteerCategory{
    id: string
    name: string
}

export class VolunteerRoleType{
    id: string
    name: string
    volunteerCategoryId: string
    mainRoleTypeId: string
    customerId: string
}

export class VolunteerViewModel {
    id: string
    displayName: string
    email: string
    creationDate: string
    phone: string
    birthDate: string
}

export class VolunteerFilter {
    fullName: string
    email: string
    gender: number
    companyName: string
    position: string
    universityId: number
    school: string
    departmant: string
    phone: string
    primaryCityId: number
    secondaryCityId: number
}